/**
 * The copies a repeatable section becomes, mirroring
 * `apps/operations/src/modules/forms-engine/support/section-repeats.ts`.
 *
 * Both sides must agree: an answer is addressed by (item, repeat key), so a key
 * this side invents that the stored record does not hold is refused on submit.
 * The repetition's name is the key — already trimmed and de-duplicated when the
 * template was saved, and the same thing the person filling it in sees.
 */
export interface SectionRepeat {
  repeatKey: string;
  repeatLabel: string | null;
}

export function sectionRepeats(section: {
  isRepeatable?: boolean;
  repeatOptions?: string[] | null;
}): SectionRepeat[] {
  if (!section.isRepeatable) return [{ repeatKey: 'default', repeatLabel: null }];
  const names = (section.repeatOptions ?? []).map((option) => option.trim()).filter(Boolean);
  // Repeatable with nothing named. Saving a template like that is refused, so
  // this only covers rows that predate the rule.
  if (names.length === 0) return [{ repeatKey: 'unconfigured', repeatLabel: null }];
  return [...new Set(names)].map((name) => ({ repeatKey: name, repeatLabel: name }));
}
